/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as NotesRouteImport } from './routes/notes'
import { Route as MeetingsRouteImport } from './routes/meetings'
import { Route as FavouritesRouteImport } from './routes/favourites'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionsIdRouteImport } from './routes/sessions.$id'
import { Route as PlansIdRouteImport } from './routes/plans.$id'
import { Route as NotesIdRouteImport } from './routes/notes.$id'
import { Route as ReadBookChapterRouteImport } from './routes/read.$book.$chapter'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesRoute = NotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingsRoute = MeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => rootRouteImport,
} as any)
const FavouritesRoute = FavouritesRouteImport.update({
  id: '/favourites',
  path: '/favourites',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIdRoute = SessionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SessionsRoute,
} as any)
const PlansIdRoute = PlansIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PlansRoute,
} as any)
const NotesIdRoute = NotesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => NotesRoute,
} as any)
const ReadBookChapterRoute = ReadBookChapterRouteImport.update({
  id: '/read/$book/$chapter',
  path: '/read/$book/$chapter',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/favourites': typeof FavouritesRoute
  '/meetings': typeof MeetingsRoute
  '/notes': typeof NotesRouteWithChildren
  '/plans': typeof PlansRouteWithChildren
  '/search': typeof SearchRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/notes/$id': typeof NotesIdRoute
  '/plans/$id': typeof PlansIdRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/read/$book/$chapter': typeof ReadBookChapterRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/favourites': typeof FavouritesRoute
  '/meetings': typeof MeetingsRoute
  '/notes': typeof NotesRouteWithChildren
  '/plans': typeof PlansRouteWithChildren
  '/search': typeof SearchRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/notes/$id': typeof NotesIdRoute
  '/plans/$id': typeof PlansIdRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/read/$book/$chapter': typeof ReadBookChapterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/favourites': typeof FavouritesRoute
  '/meetings': typeof MeetingsRoute
  '/notes': typeof NotesRouteWithChildren
  '/plans': typeof PlansRouteWithChildren
  '/search': typeof SearchRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/notes/$id': typeof NotesIdRoute
  '/plans/$id': typeof PlansIdRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/read/$book/$chapter': typeof ReadBookChapterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/favourites'
    | '/meetings'
    | '/notes'
    | '/plans'
    | '/search'
    | '/sessions'
    | '/settings'
    | '/notes/$id'
    | '/plans/$id'
    | '/sessions/$id'
    | '/read/$book/$chapter'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/favourites'
    | '/meetings'
    | '/notes'
    | '/plans'
    | '/search'
    | '/sessions'
    | '/settings'
    | '/notes/$id'
    | '/plans/$id'
    | '/sessions/$id'
    | '/read/$book/$chapter'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/favourites'
    | '/meetings'
    | '/notes'
    | '/plans'
    | '/search'
    | '/sessions'
    | '/settings'
    | '/notes/$id'
    | '/plans/$id'
    | '/sessions/$id'
    | '/read/$book/$chapter'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  FavouritesRoute: typeof FavouritesRoute
  MeetingsRoute: typeof MeetingsRoute
  NotesRoute: typeof NotesRouteWithChildren
  PlansRoute: typeof PlansRouteWithChildren
  SearchRoute: typeof SearchRoute
  SessionsRoute: typeof SessionsRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  ReadBookChapterRoute: typeof ReadBookChapterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes': {
      id: '/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof NotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meetings': {
      id: '/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof MeetingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favourites': {
      id: '/favourites'
      path: '/favourites'
      fullPath: '/favourites'
      preLoaderRoute: typeof FavouritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$id': {
      id: '/sessions/$id'
      path: '/$id'
      fullPath: '/sessions/$id'
      preLoaderRoute: typeof SessionsIdRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/plans/$id': {
      id: '/plans/$id'
      path: '/$id'
      fullPath: '/plans/$id'
      preLoaderRoute: typeof PlansIdRouteImport
      parentRoute: typeof PlansRoute
    }
    '/notes/$id': {
      id: '/notes/$id'
      path: '/$id'
      fullPath: '/notes/$id'
      preLoaderRoute: typeof NotesIdRouteImport
      parentRoute: typeof NotesRoute
    }
    '/read/$book/$chapter': {
      id: '/read/$book/$chapter'
      path: '/read/$book/$chapter'
      fullPath: '/read/$book/$chapter'
      preLoaderRoute: typeof ReadBookChapterRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface NotesRouteChildren {
  NotesIdRoute: typeof NotesIdRoute
}

const NotesRouteChildren: NotesRouteChildren = {
  NotesIdRoute: NotesIdRoute,
}

const NotesRouteWithChildren = NotesRoute._addFileChildren(NotesRouteChildren)

interface PlansRouteChildren {
  PlansIdRoute: typeof PlansIdRoute
}

const PlansRouteChildren: PlansRouteChildren = {
  PlansIdRoute: PlansIdRoute,
}

const PlansRouteWithChildren = PlansRoute._addFileChildren(PlansRouteChildren)

interface SessionsRouteChildren {
  SessionsIdRoute: typeof SessionsIdRoute
}

const SessionsRouteChildren: SessionsRouteChildren = {
  SessionsIdRoute: SessionsIdRoute,
}

const SessionsRouteWithChildren = SessionsRoute._addFileChildren(
  SessionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  FavouritesRoute: FavouritesRoute,
  MeetingsRoute: MeetingsRoute,
  NotesRoute: NotesRouteWithChildren,
  PlansRoute: PlansRouteWithChildren,
  SearchRoute: SearchRoute,
  SessionsRoute: SessionsRouteWithChildren,
  SettingsRoute: SettingsRoute,
  ReadBookChapterRoute: ReadBookChapterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
